// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b9be1fd6","453":"a89739d9","455":"92679d42","977":"228789da"}[chunkId] + ".chunk.js";
};